import { TagLink } from '@bnnvara/tags';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Link from '../Link';
import TagTitle from './styled';

export const tagPropType = PropTypes.shape({
  slug: PropTypes.string,
  name: PropTypes.string,
});

const TagList = ({ tags }) => {
  if (tags.length === 0) {
    return null;
  }

  return (
    <Fragment>
      <TagTitle>Meer over:</TagTitle>
      {tags.map((tag, index) => (
        <Fragment key={`fragment-${tag.slug}`}>
          <Link
            href={`/tags/${tag.slug}`}
            category="Zoeken"
            label={`tags-${tag.slug}`}
            action="click"
            key={`link-${tag.slug}`}
          >
            <TagLink key={tag.slug}>{tag.name}</TagLink>
          </Link>
          <span key={`comma-${tag.slug}`}>
            {index < tags.length - 1 ? ', ' : null}
          </span>
        </Fragment>
      ))}
    </Fragment>
  );
};

TagList.defaultProps = {
  tags: [],
};

TagList.propTypes = {
  tags: PropTypes.arrayOf(tagPropType),
};

export default TagList;
